import React from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  getHealthPlanStats,
  type HealthPlanStatsDto,
} from '../api/health-plan-api'
import {
  HealthPlanStatCard,
  HealthPlanStatCardDescription,
  HealthPlanStatCardTitle,
  HealthPlanStatCardValue,
  StatCardGrid,
} from './HealthPlanStatCards.styles'

interface StatCardDef {
  statKey: keyof HealthPlanStatsDto
  title: string
  description: string
}

const STAT_CARD_DEFS: readonly StatCardDef[] = [
  {
    statKey: 'totalPlans',
    title: 'Total Plans',
    description: 'Total number of health plans in the database',
  },
  {
    statKey: 'plansForSale',
    title: 'Plans for Sale',
    description: 'Plans currently available for sale',
  },
  {
    statKey: 'statesCovered',
    title: 'States Covered',
    description: 'Number of states with active health plans',
  },
  {
    statKey: 'serviceAreas',
    title: 'Service Areas',
    description: 'Number of service areas offering health plans',
  },
]

interface Props {
  year: number | undefined
}

export default function HealthPlanStatCards({ year }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ['healthPlanStats', year],
    queryFn: () => {
      if (year === undefined)
        return Promise.reject(new Error('year is required'))
      return getHealthPlanStats(year)
    },
    enabled: year !== undefined,
  })

  return (
    <StatCardGrid>
      {STAT_CARD_DEFS.map((def) => (
        <HealthPlanStatCard key={def.statKey}>
          <HealthPlanStatCardTitle>{def.title}</HealthPlanStatCardTitle>
          <HealthPlanStatCardValue>
            {isLoading || !data ? '—' : data[def.statKey].toLocaleString()}
          </HealthPlanStatCardValue>
          <HealthPlanStatCardDescription>
            {def.description}
          </HealthPlanStatCardDescription>
        </HealthPlanStatCard>
      ))}
    </StatCardGrid>
  )
}
